// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external-app {
	height: 100%;
	display: flex;
	-webkit-overflow-scrolling: touch;
}

.external-app-frame {
	border: none;
	margin: 0;
	padding: 0;
	width: 100%;
	height: calc(100vh - 144px);
	height: 100%;
	background: var(--mdh-background-color-0);
}

@media (max-width: 680px) {
	.external-app-frame {
		height: 100%;
	}
}`, "",{"version":3,"sources":["webpack://./src/widgets/MyDataHelps/Views/ExternalApplication.css"],"names":[],"mappings":"AAAA;CACC,YAAY;CACZ,aAAa;CACb,iCAAiC;AAClC;;AAEA;CACC,YAAY;CACZ,SAAS;CACT,UAAU;CACV,WAAW;CACX,2BAA2B;CAC3B,YAAY;CACZ,yCAAyC;AAC1C;;AAEA;CACC;EACC,YAAY;CACb;AACD","sourcesContent":[".external-app {\n\theight: 100%;\n\tdisplay: flex;\n\t-webkit-overflow-scrolling: touch;\n}\n\n.external-app-frame {\n\tborder: none;\n\tmargin: 0;\n\tpadding: 0;\n\twidth: 100%;\n\theight: calc(100vh - 144px);\n\theight: 100%;\n\tbackground: var(--mdh-background-color-0);\n}\n\n@media (max-width: 680px) {\n\t.external-app-frame {\n\t\theight: 100%;\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
